import React, { useEffect, useState } from 'react';
import apiClient from './ApiClient';
import './UserPanel.css';

export async function savePreferences(newPreferences) {
  try {
    const response = await apiClient.post("/preferences/", { preferences: newPreferences });
    return response.data;
  } catch (error) {
    console.error("Failed to save preferences:", error);
    throw new Error("Failed to save preferences");
  }
}

function Preferences({preferences, setPreferences}) {

  const handleInputChange = async (event) => {
    const { name, value } = event.target;
  
    // Calculate updated preferences
    const updatedPreferences = {
      ...preferences,
      [name]: value,
    };
  
    // Update state
    setPreferences(updatedPreferences);
  
    // Update server preferences
    try {
      const response = await savePreferences(updatedPreferences); // Use the updated preferences
      console.log("Preferences updated on server:", response);
    } catch (error) {
      console.error("Failed to update preferences:", error);
    }
  };

  return (
    <div className="account-panel">
      <form className="preferences-form">
        {/* <p>Subscription Tier:</p>
        <label>
          <input
            type="radio"
            name="tier"
            value="free"
            defaultChecked={preferences.tier === "free"}
            onChange={handleInputChange}
          />
          Free
        </label>
        <label>
          <input
            type="radio"
            name="tier"
            value="basic"
            defaultChecked={preferences.tier === "basic"}
            onChange={handleInputChange}
          />
          Basic
        </label>
        <label>
          <input
            type="radio"
            name="tier"
            value="poweruser"
            defaultChecked={preferences.tier === "poweruser"}
            onChange={handleInputChange}
          />
          Power User
        </label> */}

        <p>Number of playouts</p>
        <label>
          <input
            type="radio"
            name="depth"
            value="superficial"
            defaultChecked={preferences.depth === "superficial"}
            onChange={handleInputChange}
            onClick={(e) => e.target.blur()}
          />
          400
        </label>
        <label>
          <input
            type="radio"
            name="depth"
            value="quick"
            defaultChecked={preferences.depth === "quick"}
            onChange={handleInputChange}
            onClick={(e) => e.target.blur()}
          />
          1000
        </label>
        <label>
          <input
            type="radio"
            name="depth"
            value="standard"
            defaultChecked={preferences.depth === "standard"}
            onChange={handleInputChange}
            onClick={(e) => e.target.blur()}
          />
          3000
        </label>
        <label>
          <input
            type="radio"
            name="depth"
            value="deep"
            defaultChecked={preferences.depth === "deep"}
            onChange={handleInputChange}
            onClick={(e) => e.target.blur()}
          />
          12000
        </label>
        {/* <button style="margin-top: 15px;" type="submit">Update Preferences</button> */}
      </form>
    </div>
  );
}

export default Preferences;